export const FETCH_CONFIG_DATA_REQUEST = 'FETCH_CONFIG_DATA_REQUEST'
export const FETCH_CONFIG_DATA_SUCCESS = 'FETCH_CONFIG_DATA_SUCCESS'
export const FETCH_CONFIG_DATA_FALIURE = 'FETCH_CONFIG_DATA_FALIURE'
